import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LearningOfferService {
  constructor(public http: HttpClient) {}

  private header = new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': environment.apiKey,
  });
  public listLearningOffers(): Observable<any> {
    const body = {
      query: `
        query {
          listLearningOffers(filter: {visibility: {eq: true}}) {
            items {
              address
              city
              company_name
              contract_duration
              contract_type
              diploma_targeted
              email
              firstname
              id
              job_title
              lastname
              phone_number
              postal_code
              prerequisites_and_missions
              service_name
              createdAt
              file
            }
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public getLearningOffer(id: string): Observable<any> {
    const body = {
      query: `
        query {
          getLearningOffer(id: "${id}") {
            address
            city
            company_name
            contract_duration
            contract_type
            diploma_targeted
            email
            firstname
            id
            job_title
            phone_number
            lastname
            postal_code
            prerequisites_and_missions
            service_name
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public sendLearningOffer(
    address: string,
    city: string,
    company_name: string,
    email: string,
    firstname: string,
    lastname: string,
    phone_number: string,
    postal_code: string,
    siret: string,
    contract_duration: string,
    contract_type: string,
    diploma_targeted: string,
    file: string,
    job_title: string,
    service_name: string
  ): Observable<any> {
    const body = {
      query: `
        mutation {
          sendLearningOffer(
            company: {
              address: "${address}", 
              city: "${city}", 
              company_name: "${company_name}", 
              email: "${email}", 
              firstname: "${firstname}", 
              lastname: "${lastname}", 
              phone_number: "${phone_number}", 
              postal_code: "${postal_code}", 
              siret: "${siret}"
            }, offer: {
              contract_duration: "${contract_duration}", 
              contract_type: "${contract_type}", 
              diploma_targeted: "${diploma_targeted}", 
              file: "${file}", 
              job_title: "${job_title}", 
              service_name: "${service_name}"
            }) {
            code
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public editLearningOffer(
    id: string,
    address?: string,
    city?: string,
    company_name?: string,
    firstname?: string,
    lastname?: string,
    phone_number?: string,
    postal_code?: string,
    social_reason?: string,
    contract_duration?: string,
    contract_type?: string,
    diploma_targeted?: string,
    job_title?: string,
    prerequisites_and_missions?: string,
    service_name?: string
  ): Observable<any> {
    const body = {
      query: `
        mutation {
          updateLearningOffer(
            input: {
            id: "${id}",
            address: "${address}", 
            city: "${city}", 
            company_name: "${company_name}", 
            contract_duration: "${contract_duration}", 
            contract_type: "${contract_type}", 
            diploma_targeted: "${diploma_targeted}", 
            firstname: "${firstname}", 
            job_title: "${job_title}", 
            lastname: "${lastname}", 
            phone_number: "${phone_number}", 
            postal_code: "${postal_code}", 
            prerequisites_and_missions: "${prerequisites_and_missions}", 
            service_name: "${service_name}", 
            social_reason: "${social_reason}"
          }) {
            id
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public createLearningOffer(data: any): Observable<any> {
    const body = {
      query: `
        mutation {
          createLearningOffer(
            input: {
            address: "${data.address}", 
            city: "${data.city}", 
            company_name: "${data.company_name}", 
            contract_duration: "${data.contract_duration}", 
            contract_type: "${data.contract_type}", 
            diploma_targeted: "${data.diploma_targeted}", 
            email: "${data.email}", 
            firstname: "${data.firstname}", 
            job_title: "${data.job_title}", 
            lastname: "${data.lastname}", 
            phone_number: "${data.phone_number}", 
            postal_code: "${data.postal_code}", 
            service_name: "${data.service_name}", 
            file: "${data.file}",
            siret: "${data.siret}",
            createdBy: "EMPLOYER",
            visibility: false            
          }) {
            id
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }
}
